<div style="height: 100vh; background-color: #fff;">
  <div class="d-flex justify-content-between flex-column h-100">
    <div class="logo-container">
      <div class="phialogo"></div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="w-50 heading-container p-2">
        <div class="m-3 heading text-center">Ignite</div>
        <div class="d-flex justify-content-center mb-5">
          <button class="sign-in-btn w-100" type="button" (click)="onLogin()">
            Login
          </button>
        </div>
        <div class="py-2">
          <div class="new-user-wrapper">
            <span>New to Ignite?</span>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="new-user-btn"
              type="button"
              (click)="onCreateAccount()"
            >
              Create account
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="p-2 disclaimer">
      Disclaimer : Ignite is maintained by The Phia Group, LLC and is intended
      for authorized users only. By logging into Ignite, you attest that you
      have read and understood this notice, and that you agree to use Ignite in
      accordance with The Phia Group's policies and procedures. All data
      contained within Ignite is the property of The Phia Group. Your activities
      on this platform may be monitored, intercepted, recorded, read, copied, or
      captured in any manner without prior notice.
    </div>
  </div>
</div>
